




import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'VerticalLayout'
})
export default class VerticalLayout extends Vue {}
